import { Badge, type BadgeProps } from '@/components/ui/Badge';
import {
  ACCESS_LABELS,
  LOGIN_ROLE_LABELS,
  ONLINE_ACCOUNT_STATUS_LABELS,
} from '@/features/onlineAccounts/model';
import type { OnlineAccountAccess, OnlineAccountStatus, OnlineLoginRole } from '@/types/database';

type Variant = NonNullable<BadgeProps['variant']>;

const STATUS_VARIANT: Record<OnlineAccountStatus, Variant> = {
  active: 'success-soft',
  closed: 'muted',
};

export function OnlineAccountStatusBadge({ status }: { status: OnlineAccountStatus }) {
  return (
    <Badge variant={STATUS_VARIANT[status]} className="whitespace-nowrap">
      {ONLINE_ACCOUNT_STATUS_LABELS[status]}
    </Badge>
  );
}

const ACCESS_VARIANT: Record<OnlineAccountAccess, Variant> = {
  owner: 'info',
  manage: 'info-soft',
  edit: 'secondary',
  view: 'outline',
  login: 'outline',
};

export function AccessBadge({ access }: { access: OnlineAccountAccess }) {
  return (
    <Badge variant={ACCESS_VARIANT[access]} className="whitespace-nowrap">
      {ACCESS_LABELS[access]}
    </Badge>
  );
}

export function LoginRoleBadge({ role }: { role: OnlineLoginRole }) {
  return (
    <Badge variant={role === 'admin' ? 'info-soft' : 'secondary'} className="whitespace-nowrap">
      {LOGIN_ROLE_LABELS[role]}
    </Badge>
  );
}
